/*
 * @Author: cgh
 * @Date: 2022-08-01 10:49:32
 * @LastEditors: cgh
 * @LastEditTime: 2022-09-01 10:20:58
 * @Description: file content
 */

import axios from 'axios';
import config from '@/config';

const { iffApi } = config.ctx;

export const jzxxService = {

  // 建筑信息列表查询
  jzxxQuery: (id, params) => { return axios.get(`${iffApi}/xfpg/pgxm/${id}/jzxx`, { params: params }); },

  // 获取详情
  getjzxxInfo: (id, jzid) => { return axios.get(`${iffApi}/xfpg/pgxm/${id}/jzxx/${jzid}`); },
  // 添加建筑信息
  addJzxx: (id, fd) => { return axios.post(`${iffApi}/xfpg/pgxm/${id}/jzxx`, fd); },
  // 修改评估成员
  updateJzxx: (id, jzid, fd) => { return axios.put(`${iffApi}/xfpg/pgxm/${id}/jzxx/${jzid}`, fd); },

  // 删除建筑信息
  delJzxx: (id, jzid) => { return axios.delete(`${iffApi}/xfpg/pgxm/${id}/jzxx/${jzid}`); }

};
